// extracted by mini-css-extract-plugin
export default {"cls1":"VD1ZkLgdYdoR5TQ2vmeL","cls2":"mA098L9N470MDx2xqliR VD1ZkLgdYdoR5TQ2vmeL"};